import { createTranslator, useI18n, type MessageKey, type Vars } from '@vlm/i18n';
import { prefs } from '@vlm/ui';
import { ar } from './ar';
import { en, type PlatformMessages } from './en';

export type { PlatformMessages };
export type Key = MessageKey<PlatformMessages>;

/** One stable object: I18nProvider memoises on it. */
export const messages = { en, ar };

/** `const { t, fmt, lang, dir } = useT()` — keys are checked against en.ts. */
export const useT = () => useI18n<PlatformMessages>();

export type T = ReturnType<typeof useT>['t'];

/** t() outside React (the session layer's toasts), in the language on screen. */
export function translate(key: Key, vars?: Vars): string {
  return createTranslator(prefs.get().lang, messages)(key, vars);
}
